import React, { Component } from "react";
import { UserProvider } from "./contexts/userContext";
import { CartProvider } from "./contexts/cartContext";
import { CurrencyProvider } from './contexts/currencyContext'; // Import the provider
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import route files
import AdminRoutes from "./routes/adminRoutes";
import ArtistRoutes from "./routes/artistRoutes";
import UserRoutes from "./routes/userRoutes";
import UtilityRoutes from "./routes/utilityRoutes";


const getBaseName = () => {
  return window.location.hostname === "localhost" ? "" : "/ig1";
};

const App = () => {
  return (
    <Router basename={getBaseName()}>
      <UserProvider>
        <CartProvider>
          <CurrencyProvider>
            <Routes>
              
              {/* Importing routes from separate files */}
              {AdminRoutes()}
              {ArtistRoutes()}
              {UserRoutes()}
              {UtilityRoutes()}      
            
            </Routes>        
          </CurrencyProvider>
        </CartProvider>
      </UserProvider>      
    </Router>
  );
};
export default App;
